import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from '../../../environments/environment';

/**
 * Shown when a Custom Acknowledge URL Type's delivery check fails (the client's
 * portal was unreachable or returned an error) - the recipient lands here instead
 * of being sent to a non-functional external URL.
 */
@Component({
  selector: 'grabbill-client-acknowledge-error',
  templateUrl: './acknowledge-error.component.html',
  styleUrls: ['./acknowledge-error.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AcknowledgeErrorComponent {
  get environment() {
    return environment.config;
  }
}
